
/* TODO : copy this component in the ui-kit when the front-seller is migrated in Vue3, then remove it from
the front-seller and use the ui-kit one instead */

import { defineComponent, ref, Ref, computed, PropType } from 'vue'
import { IdfIcon } from '@invivodf/ui-kit'
import { IdfAccordionKind } from './IdfAccordion.model'

export default defineComponent({
  name: 'idf-accordion',
  props: {
    kind: {
      type: String as PropType<IdfAccordionKind>,
      default: 'plus' as IdfAccordionKind,
      validator: (value: IdfAccordionKind) => Object.values(IdfAccordionKind).includes(value),
    },
    openDefault: {
      type: Boolean,
      default: false,
    },
  },
  components: { IdfIcon },
  setup(props) {
    const isOpen = ref(props.openDefault)
    const accordionContent: Ref<HTMLElement | undefined> = ref()

    const currentIcon = computed(() => {
      if (props.kind === IdfAccordionKind.CARET) {
        return isOpen.value ? 'caret-up' : 'caret-down'
      }
      return isOpen.value ? 'minus' : 'plus'
    })

    const getContentHeight = (): string => {
      if (!accordionContent.value || accordionContent.value.scrollHeight <= 0) return '0'
      return `calc(${accordionContent.value.scrollHeight}px + var(--idf-spacing-2) * 2)`
    }

    const onItemClick = () => {
      isOpen.value = !isOpen.value
    }

    return { accordionContent, isOpen, currentIcon, onItemClick, getContentHeight }
  },
})
